import type { GridRowSelectionModel } from '@mui/x-data-grid';
import type { MeasurementsStats } from '@vy/api-definition';
import { withDefault } from '@vy/utils';
import React, { useCallback } from 'react';
import { DataMetringMeasurementsTable } from '../DataMetringMeasurementsTable';

type DataMeteringContentProps = {
  selectedMeasurementsIds: string[];
  onMeasurementSelectionChange(measurements: string[]): void;
  measurementsStats: MeasurementsStats[];
  isLoading: boolean;
  totalCount: number;
  totalValue: number;
  editingAllowed: boolean;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
};

export const DataMeteringContent: React.FC<DataMeteringContentProps> = ({
  onMeasurementSelectionChange,
  selectedMeasurementsIds,
  measurementsStats,
  totalCount,
  totalValue,
  isLoading,
  editingAllowed,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
}) => {
  const onMeasurementSelection = useCallback(
    (selectedRowIds: GridRowSelectionModel) => {
      const rowIds = Array.from(selectedRowIds.ids).map(String);
      onMeasurementSelectionChange(rowIds);
    },
    [onMeasurementSelectionChange],
  );

  return (
    <DataMetringMeasurementsTable
      tableName="data-metering-measurements"
      checkboxSelectionAllowed={editingAllowed}
      selectedMeasurementsIds={selectedMeasurementsIds}
      totalValue={totalValue}
      onRowSelectionModelChange={onMeasurementSelection}
      items={withDefault(measurementsStats, [])}
      itemsCount={totalCount}
      loadingItems={isLoading}
      getRowId={(row) => row.id}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
    />
  );
};
